/* línkè · 活动实时窗（路线图任务 ④）===============================
   终端风的只读浮层：实时看Sael在调什么工具、结果如何。
   开关 `activity_window` 关 → 整个组件不渲染任何东西（零侵入）。
   数据来自 lib/activityLog（Chat.jsx 把 SSE 事件 push 进去）。
   纯前端浮层、非新路由——远离 iOS PWA 雷区。
   ================================================================ */
import { useState, useEffect, useRef } from 'react';
import { TerminalSquare, X, Trash2 } from 'lucide-react';
import { useFlag } from '../lib/flags.js';
import { useActivityLog, clearActivity } from '../lib/activityLog.js';

const KIND_LABEL = {
  tool_use: '▸ 调用',
  tool_result: '✓ 结果',
  info: '·',
  error: '✗ 出错',
};

function fmtTime(ts) {
  const d = new Date(ts);
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

function lineClass(e) {
  if (e.kind === 'error' || e.ok === false) return 'aw-line aw-line-err';
  if (e.kind === 'tool_use') return 'aw-line aw-line-call';
  if (e.kind === 'tool_result') return 'aw-line aw-line-ok';
  return 'aw-line aw-line-info';
}

export default function ActivityWindow() {
  const [on] = useFlag('activity_window');
  const [open, setOpen] = useState(false);
  const log = useActivityLog();
  const bodyRef = useRef(null);
  const lastSeen = useRef(0);

  // 面板打开时，新行进来自动滚到底
  useEffect(() => {
    if (open && bodyRef.current) {
      bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
    }
  }, [log, open]);

  // 关着面板时，有新活动让浮标亮一下
  const hasNew = !open && log.length > 0 && log[log.length - 1].id > lastSeen.current;
  useEffect(() => {
    if (open && log.length > 0) lastSeen.current = log[log.length - 1].id;
  }, [open, log]);

  if (!on) return null;

  return (
    <>
      <button
        className={'aw-fab' + (hasNew ? ' aw-fab-live' : '')}
        onClick={() => setOpen((v) => !v)}
        aria-label="活动实时窗"
        title="活动实时窗"
      >
        <TerminalSquare size={18} strokeWidth={1.7} />
      </button>

      {open && (
        <>
          <div className="aw-scrim" onClick={() => setOpen(false)} />
          <div className="aw-panel" role="dialog" aria-label="活动实时窗">
            <div className="aw-head">
              <span className="aw-title">
                <TerminalSquare size={14} strokeWidth={1.7} /> 活动实时窗
              </span>
              <span className="aw-head-actions">
                <button className="aw-icon-btn" onClick={clearActivity} title="清空">
                  <Trash2 size={13} strokeWidth={1.6} />
                </button>
                <button className="aw-icon-btn" onClick={() => setOpen(false)} title="关闭">
                  <X size={15} strokeWidth={1.8} />
                </button>
              </span>
            </div>
            <div className="aw-body" ref={bodyRef}>
              {log.length === 0 ? (
                <div className="aw-empty">还没有活动。Sael下次调用记忆工具时，会实时显示在这里。</div>
              ) : (
                log.map((e) => (
                  <div key={e.id} className={lineClass(e)}>
                    <span className="aw-ts">{fmtTime(e.ts)}</span>
                    <span className="aw-kind">{KIND_LABEL[e.kind] || e.kind}</span>
                    <span className="aw-text">
                      {e.name ? <b className="aw-name">{e.name}</b> : null}
                      {e.summary ? ' ' + e.summary : ''}
                      {e.text ? ' ' + e.text : ''}
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}
